import { forwardRef } from 'react';

import { FieldMappingJsonEditor, FieldMappingTextEditorProps } from '@components/text-editors';
import { FieldMappingData } from '@components/text-editors/addons/field-mapping';
import { EditorMethods } from '@components/text-editors/text-editor';

import { FormFieldProps, FormValidatorType } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingJsonEditorProps<T = unknown> = FormFieldProps<
  FieldMappingTextEditorProps,
  T
> &
  FieldMappingData;

export const FormFieldMappingJsonEditor = forwardRef<
  EditorMethods,
  FormFieldMappingJsonEditorProps<any>
>((props, ref) => {
  // Validate JSON through the form so Save is blocked on invalid input, not just
  // the live inline error. Template-tolerant, since the field allows {{ variables }}.
  const validators: FormValidatorType[] = ['json-template', ...(props.validators ?? [])];
  const formFieldProps = useFormField({ ...props, validators, valueType: 'text-editor' });
  return <FieldMappingJsonEditor ref={ref} {...props} {...formFieldProps} />;
});
